import React from 'react';
import { CalendarDays } from 'lucide-react';
import HRISListPage from '../HRISListPage';
import { getLeaves, createLeave, updateLeave, deleteLeave, getEmployeeList } from '../hrisApi';

const LEAVE_TYPES = ['Annual Leave', 'Sick Leave', 'Casual Leave', 'Maternity Leave', 'Paternity Leave', 'Unpaid Leave'];
const STATUS_OPTIONS = ['Draft', 'Open', 'Approved', 'Rejected', 'Cancelled'];

const columns = [
  { key: 'employeeName', label: 'Employee' },
  { key: 'leaveType', label: 'Leave Type' },
  { key: 'fromDate', label: 'From Date' },
  { key: 'toDate', label: 'To Date' },
  { key: 'totalDays', label: 'Days', render: (v) => v ? `${v} day${v > 1 ? 's' : ''}` : '—' },
  { key: 'reason', label: 'Reason', render: (v) => v ? (v.length > 40 ? v.slice(0, 40) + '…' : v) : '—' },
  { key: 'status', label: 'Status', badge: true },
];

const formFields = [
  { key: 'employeeName', label: 'Employee', type: 'select', required: true, optionsLoader: getEmployeeList },
  { key: 'leaveType', label: 'Leave Type', type: 'select', required: true, options: LEAVE_TYPES },
  { key: 'fromDate', label: 'From Date', type: 'date', required: true },
  { key: 'toDate', label: 'To Date', type: 'date', required: true },
  { key: 'totalDays', label: 'Total Days', type: 'number', placeholder: 'Auto-calculated' },
  { key: 'reason', label: 'Reason', type: 'textarea', placeholder: 'Reason for leave...' },
  { key: 'status', label: 'Status', type: 'select', options: STATUS_OPTIONS, defaultValue: 'Draft' },
];

const Leaves = () => (
  <HRISListPage
    title="Leaves"
    description="Manage employee leave applications, allocations, and approvals"
    icon={<CalendarDays />}
    columns={columns}
    fetchData={getLeaves}
    createData={createLeave}
    updateData={updateLeave}
    deleteData={deleteLeave}
    formFields={formFields}
    entityName="Leave Application"
    searchPlaceholder="Search by employee or leave type..."
  />
);

export default Leaves;
